import PropTypes from 'prop-types';

const file = PropTypes.shape({
    id: PropTypes.number.isRequired,
    origFileName: PropTypes.string.isRequired,
    icon: PropTypes.string,
    mimeType: PropTypes.string.isRequired,
    createdOn: PropTypes.string.isRequired,
    inAwsBucket: PropTypes.number,
    patientId: PropTypes.string.isRequired,
});

export { file };
